import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import * as CartService from 'services/cart'
import { getUserChannelId } from 'utils/_helpers'

const useCart = () => {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({ isAuthorized: auth.user != null }),
    shallowEqual,
  )
  const { channelId, uuid } = useSelector(({ common }) => ({
    channelId: common.channelId,
    uuid: common.uuid,
  }))

  const formatCartItem = (data) => {
    let formattedData = {
      ...data,
      channel: getUserChannelId(channelId),
    }

    if (!isAuthorized) {
      formattedData.uuid = uuid
    }

    return formattedData
  }

  const CartItemAction = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        // call backend cart api
        const response = await CartService.CartItemAction(formatCartItem(data))
        resolve(response)
      } catch (error) {
        // reject if api call had error
        reject(error)
      }
    })
  }

  const DeleteCart = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        await CartService.DeleteUserCart(formatCartItem({ id }))
        resolve()
      } catch (error) {
        // reject if api call had error
        reject(error)
      }
    })
  }

  const DeleteCartItem = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        await CartService.DeleteCartItem(formatCartItem(id))
        resolve()
      } catch (error) {
        // reject if api call had error
        reject(error)
      }
    })
  }

  return {
    CartItemAction,
    DeleteCartItem,
    DeleteCart
  }
}

export default useCart
